import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMailSend = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M21 10.594v-1.68C21 6.15 19.155 3.9 16.418 3.9H7.582C4.845 3.9 3 6.15 3 8.913v6.181c0 2.765 1.845 5.013 4.582 5.006h4.336M18.428 19.814l2.571-2.561-2.571-2.562M21 17.253h-5.695"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m17.31 9.166-3.998 3.252a2.07 2.07 0 0 1-2.574 0L6.705 9.166"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMailSend);
export default ForwardRef;
